import React from 'react';
import PropTypes from 'prop-types';

const AlertMessage = ({ type, text, tag, dismissable = true, extraClass = '', hideTag = false }) => {
  if (['success', 'info', 'warning', 'danger'].indexOf(type) < 0) {
    type = 'info';
  }

  if (!tag) {
    tag = type.charAt(0).toUpperCase() + type.slice(1);
  }

  const dismiss = (event) => {
    event.preventDefault();

    let target = event.target;
    let alert = target.parentNode;

    alert.parentNode.removeChild(alert);
  };

  return (
    <div className={`alert alert-${type}` + (dismissable ? ' alert-dismissable' : '') + ' ' + extraClass}>
      {dismissable && (
        <a href="#" onClick={dismiss} className="close" data-dismiss="alert" aria-label="close">
          &times;
        </a>
      )}
      {!hideTag && (
        <span>
          <strong>{tag}</strong>:{' '}
        </span>
      )}{' '}
      {text}
    </div>
  );
};

AlertMessage.propTypes = {
  type: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  tag: PropTypes.string,
  dismissable: PropTypes.bool,
  extraClass: PropTypes.string,
  hideTag: PropTypes.bool,
};

export default AlertMessage;
